module.exports = __webpack_public_path__ + "static/media/noresultsfound.c809e071.svg";